itsoftApp.createModule("animateScroll", ["windowResize"], function () {
    /* global SmoothScroll */
    var maxMobileWidth = 767;
    var module = this;
    var loaded = false;
    var pageHeader = document.querySelector("[data-fixed='true']"); /* есть ли фиксированная шапка */
    var pageChooseFixed = document.querySelector('.js-choose-fixed');
    var viewportSize = itsoftApp.utils.getViewportSize(); /* определяем текущий вьюпорт */
    var chooseFixedHeight;
    var scroll;

    /* переменные для подсвечивания ссылок по скролу */
    var navInstructuion = document.querySelector('.js-choose-fixed');
    var linksForBlock = document.querySelectorAll('.js-link-for-block');
    var blocks = [];
    var blockName;
    var oldCurrentLink;
    var block;
    var blockItem;
    var blockOffset;
    var blockHeight;
    var currentLinks;
    /* переменные для подсвечивания ссылок по скролу */

    var getViewportSize = function () {
        viewportSize = itsoftApp.utils.getViewportSize();
    };

    var startScroll = function (target, padding, speed, speedAsDuration) {
        var defaultPadding = 0;

          /* вычисляет отступ сверху */
        if (pageHeader) {
            if (!itsoftApp.commonVars.headerHeight) {
                itsoftApp.utils.getHeaderHeight(); /* берём высоту шапки */
            }

            if (pageChooseFixed) {
                chooseFixedHeight = pageChooseFixed.clientHeight;
                if (target.hasAttribute("data-offset")) {
                    if (viewportSize <= maxMobileWidth) {
                        defaultPadding = itsoftApp.commonVars.headerHeight * 1.5;
                    } else {
                        defaultPadding = itsoftApp.commonVars.headerHeight;
                    }
                } else if (target.hasAttribute("data-offset-mobile") && viewportSize <= maxMobileWidth) {
                    defaultPadding = itsoftApp.commonVars.headerHeight * 1.5;
                } else {
                    defaultPadding = itsoftApp.commonVars.headerHeight + chooseFixedHeight;
                }
            } else {
                if (target.hasAttribute("data-offset")) {
                    if (viewportSize <= maxMobileWidth) {
                        defaultPadding = itsoftApp.commonVars.headerHeight * 1.5;
                    } else {
                        defaultPadding = itsoftApp.commonVars.headerHeight;
                    }
                } else if (target.hasAttribute("data-offset-mobile") && viewportSize <= maxMobileWidth) {
                    defaultPadding = itsoftApp.commonVars.headerHeight * 1.5;
                } else {
                    defaultPadding = itsoftApp.commonVars.headerHeight;
                }
            }
        }

          /* добавляем отступ сверху, если, например, есть фиксированная шапка */
        var settings = {
            offset: defaultPadding
        };

          /* вычисляем скорость и время, за которое произойдёт прокрутка */

        if (speed) {
            settings.speed = speed;
        }

        settings.durationMin = 500;

        if (speedAsDuration) {
            settings.speedAsDuration = speedAsDuration;
        }

        settings.customEasing = function (time) {
            return -(Math.cos(Math.PI * time) - 1) / 2;
        };

          /* Уничтожаем предыдущий экземпляр, если он есть */
        if (scroll) {
            scroll.cancelScroll();
            scroll.destroy();
            scroll = "";
        }
          
        scroll = new SmoothScroll();

        if (!document.body.classList.contains("is-popup-opened")) {
            scroll.animateScroll(target, "auto", settings);
        } else {
            setTimeout(function () {
                scroll.animateScroll(target, "auto", settings);
            }, 800);
        }
    };

    /* подсвечивание ссылок по скролу */
    function offsetGoTo(el) {
        var rect = el.getBoundingClientRect(),
            scrollTop = window.scrollY || document.documentElement.scrollTop;
        return rect.top + scrollTop;
    }

    function setLinkForBlock() {
        oldCurrentLink = document.querySelectorAll('.js-link-for-block._active');
        var layer = document.querySelector('header').clientHeight + navInstructuion.clientHeight;
        if (oldCurrentLink) {
            for (let index = 0; index < oldCurrentLink.length; index++) {
                var el = oldCurrentLink[index];
                el.classList.remove('_active');
            }
        }
        for (let index = 0; index < blocks.length; index++) {
            block = blocks[index];
            blockItem = document.querySelector('#' + block);
            if (blockItem) {
                blockOffset = offsetGoTo(blockItem);
                blockHeight = blockItem.clientHeight;
                if (((scrollY + layer + 1) >= blockOffset) && (scrollY + layer) < (blockOffset + blockHeight - 1)) {
                    currentLinks = document.querySelectorAll('.js-link-for-block[href="#' + block + '"]');
                    for (let index = 0; index < currentLinks.length; index++) {
                        var currentLink = currentLinks[index];
                        currentLink.classList.add('_active');
                    }
                }
            }
        }
    }
    if (linksForBlock.length > 0) {
        for (let index = 0; index < linksForBlock.length; index++) {
            var el = linksForBlock[index];
            blockName = el.getAttribute('href').replace('#', '');
            if (blockName != '' && !~blocks.indexOf(blockName)) {
                blocks.push(blockName);
            }
        }

        window.addEventListener('scroll', setLinkForBlock);
        window.addEventListener('resize', setLinkForBlock);
    };
    /* подсвечивание ссылок по скролу*/

    var load = function (target, padding, speed, speedAsDuration) {
      /* если библиотека для плавной анимации пока не загружена, загружаем... */
        if (!loaded) {
            itsoftApp.loadScript("/assets/scripts/smoothScroll/smooth-scroll.min.js", function () {
                loaded = true;
                startScroll(target, padding, speed, speedAsDuration);
            });
        } else {
            // иначе сразу запускаем функцию
            startScroll(target, padding, speed, speedAsDuration);
        }
    };

    var initAnimateScroll = function (el) { // el, padding
        el.addEventListener("click", function (evt) {
            evt.preventDefault();
            var scrollId = evt.currentTarget.href;

            /* исключительно для языковых версий */
            var packsItems = document.querySelectorAll(".packs__image-item");
            var scrollSection = document.querySelector(".js-scroll-section");
            /* */
          
            if (!scrollId || !(scrollId = scrollId.split("#")[1])) {
                return;
            }

            /* Чтобы якорные ссылки работали, когда на странице присутствует пачки и слайдер с ленивой инициализацией */

            var pageInter = document.querySelector(".page");
            var buyingLinks = document.querySelectorAll("[href='#buying']");

            /* Находим элемент, до которого нуңно прокрутить страницу, и передаём его в функцию */
            var target = document.querySelector("#" + scrollId);

            if (buyingLinks.length > 0 && !pageInter.classList.contains("js-lazy-start")) {
                pageInter.classList.add("js-lazy-start");

                Array.prototype.forEach.call(packsItems, function (packsItem) {
                    if (!packsItem.classList.contains("lazyloaded")) {
                        window.lazySizes.loader.unveil(packsItem);
                    }
                });

                if (scrollSection && scrollSection.classList.contains("js-invisible")) {
                    scrollSection.classList.remove("js-invisible");
                    scrollSection.classList.add("js-visible");
                    itsoftApp.modules.scrollActions.callback(function () {
                        pageInter.classList.remove("js-lazy-start");
                        pageInter.classList.add("js-lazy-completed");
                        load(target);
                    }, true, false);
                } else {
                    setTimeout(function () {
                        pageInter.classList.remove("js-lazy-start");
                        pageInter.classList.add("js-lazy-completed");
                        load(target);
                    }, 300)
                }
            } else {
                load(target);
            }
        });
    };

    var links = document.querySelectorAll("a[href^='#']:not([href='#'])");

    /* Проходимся по всем элементам, у которых в href есть хэш */
    Array.prototype.forEach.call(links, function (el) {
        initAnimateScroll(el);
    });

    module.callback = load;

    itsoftApp.modules.windowResize.addEvent(getViewportSize);

    // const hash = location.hash;

    // if (hash) {
    //     const hashElement = document.querySelector(hash);
    //     alert(hashElement)
    // }

    // if (hash && hashElement) {
    //     load(hashElement);
    // }
});